import type { ServiceIntervalConfig, WearStatus } from '../../types';
import { getWearPercent } from '../getWearPercent';

export const getWorstWear = ({
    interval,
    units
}: {
    interval?: ServiceIntervalConfig;
    units: Array<{ usage: number }>;
}): WearStatus => {
    if (!interval || interval.value <= 0) {
        return { configured: false };
    }

    const worstUsage = units.reduce((highest, unit) => Math.max(highest, unit.usage), 0);

    return getWearPercent({ interval, usage: worstUsage });
};
